import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import TextBox from '../../components/TextBox.js';
import ComboBox from '../../components/ComboBox.js';
import CheckBox from '../../components/CheckBox.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';

const UsersBodyAction1 = ReactRouterDOM.withRouter(function ({ data, updateData, validated }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [dataSourceBranchId, setDataSourceBranchId] = React.useState([]);

  React.useEffect(() => {
    fetchDataSourceBranchId();
  }, []);

  const fetchDataSourceBranchId = async function () {
    let records = null;
    try {
      records = await ApiService.getBranches(null);
    }
    catch (error) {
      setError(error);
      return;
    }
    setDataSourceBranchId(
      records.map((record) => [record.branchId, record.name])
    );
  }
  
  return (
    <div>
      <div>
        <div className="d-flex flex-wrap">
          <div className="pt-2 col-lg-6 col-md-6 col-sm-6 col-6">
            <TextBox
              label={words.username}
              value={data.username}
              onChange={(value) => updateData('username', value)}
              validated={validated}
              required
            />
          </div>
        </div>
        <div className="d-flex flex-wrap">
          <div className="pt-2 col-lg-6 col-md-6 col-sm-6 col-6">
            <TextBox
              label={words.firstName}
              value={data.firstName}
              onChange={(value) => updateData('firstName', value)}
              validated={validated}
            />
          </div>
          <div className="pt-2 col-lg-6 col-md-6 col-sm-6 col-6">
            <TextBox
              label={words.lastName}
              value={data.lastName}
              onChange={(value) => updateData('lastName', value)}
              validated={validated}
            />
          </div>
          <div className="pt-2 col-lg-12 col-md-12 col-sm-12 col-12">
            <TextBox
              label={words.email}
              value={data.email}
              onChange={(value) => updateData('email', value)}
              validated={validated}
            />
          </div>
          <div className="pt-2 col-lg-6 col-md-6 col-sm-6 col-6">
            <ComboBox
              label={words.branch}
              value={data.branchId}
              onChange={(value) => updateData('branchId', value)}
              validated={validated}
              dataSource={dataSourceBranchId}
            />
          </div>
        </div>
        <div className="d-flex flex-wrap">
          <div className="pt-2 col-lg-6 col-md-6 col-sm-6 col-6">
            <CheckBox
              label={words.enabled}
              value={data.enabled}
              onChange={(value) => updateData('enabled', value)}
              validated={validated}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
})

export default UsersBodyAction1;
